import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { TurnstileGateComponent } from './shared/components/turnstile-gate/turnstile-gate.component';
import { ThemeService } from './core/services/theme.service';
import { LanguageService } from './core/services/language.service';
import { TurnstileVerificationService } from './core/services/turnstile-verification.service';

@Component({
  selector: 'demo-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TurnstileGateComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  // themeService/languageService: injected eagerly (unused directly) so
  // theme/language state is initialized before any child component reads
  // it -- TurnstileGateComponent needs both resolved to render its own
  // copy/styling correctly.
  //
  // turnstileService: `protected`, not `private` like the two above --
  // its `verified()` signal IS read directly from app.component.html to
  // decide between the real shell and <demo-turnstile-gate>, and Angular's
  // strictTemplates rejects template access to `private` members (this
  // project already hit that exact class of bug once, see
  // plan-frontend-reinvent-viajes-app.md).
  constructor(
    private readonly themeService: ThemeService,
    private readonly languageService: LanguageService,
    protected readonly turnstileService: TurnstileVerificationService,
  ) {}
}
